<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import { clickoutside } from '@svelte-put/clickoutside';
import * as m from '@app/paraglide/messages.js';

let showDropdown = $state(false);

const alignCenter = () => {
    applyAlignment('align center', 'center', 'center');
}

const applyAlignment = (actionName, alignment, xPos) => {
    if (window.quillEditor){
        window.quillEditor.formatLine(0, 9999, 'align', alignment, "silent");
    }
    
    
    eventGroupState[projectState.selected].selected.forEach(eventIndex => {
        eventGroupState[projectState.selected].events[eventIndex].alignment = alignment || "left";
        eventGroupState[projectState.selected].events[eventIndex].xPos = xPos;
    });

    insertHistoryAction({
        name: actionName,
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
    
    showDropdown = false;
}

const toggleDropdown = () => {
    showDropdown = !showDropdown;
}

const closeDropdown = () => {
    showDropdown = false;
}

const leftJustifyCenterPos = () => applyAlignment('left justify / center position', '', 'center');
const centerJustifyCenterPos = () => applyAlignment('center justify / center position', 'center', 'center');
const rightJustifyCenterPos = () => applyAlignment('right justify / center position', 'right', 'center');

let isDisabled = $derived(!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0);
</script>

<li class="nav-item" title={m.align_center_title()}>
    <div class="btn-group btn-group-sm" role="group" use:clickoutside onclickoutside={closeDropdown}>
        <button 
            type="button" 
            class="btn btn-link nav-link" 
            id="align-center-btn"
            aria-label={m.align_center_aria_label()}
            disabled={isDisabled}
            onclick={alignCenter}
        >
            <i class="bi bi-text-center"></i>
        </button>
        <button 
            type="button" 
            class="btn btn-link nav-link dropdown-toggle dropdown-toggle-split" 
            aria-expanded={showDropdown}
            disabled={isDisabled}
            onclick={toggleDropdown}
        >
            <span class="visually-hidden">{m.toggle_dropdown()}</span>
        </button>
        <ul class="dropdown-menu" class:show={showDropdown}>
            <li><a class="dropdown-item" href="#!/" onclick={leftJustifyCenterPos}>{m.align_center_left_justify_center_pos()}</a></li>
            <li><a class="dropdown-item" href="#!/" onclick={centerJustifyCenterPos}>{m.align_center_center_justify_center_pos()}</a></li>
            <li><a class="dropdown-item" href="#!/" onclick={rightJustifyCenterPos}>{m.align_center_right_justify_center_pos()}</a></li>
        </ul>
    </div>
</li>
<style>
    .dropdown-menu {
        position: relative;
        top: 30px;
        left: 15px;
    }
</style>
